export function isBot(): boolean {
  return /Prerender|Googlebot|Bingbot|Yandex/i.test(window.navigator.userAgent);
}
